module.exports = "<div\n  data-angular-treeview=\"true\"\n  data-tree-id=\"abc\"\n  data-tree-model=\"treedata\"\n  data-node-id=\"id\"\n  data-node-label=\"label\"\n  data-node-children=\"children\" >\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/dealer/tree/index.html
// module id = ./src/app/components/dealer/tree/index.html
// module chunks = main